import React, { useState } from "react";

/**
 * Public "L'intervista" section shown on drop pages when the admin has
 * provided an interview_youtube_url.
 *
 * Click the cover → the YouTube iframe replaces the poster (in-place, no
 * modal) with `autoplay=1`. Uses the maxresdefault thumbnail with graceful
 * fallback to hqdefault for older/less-popular clips.
 */
export default function InterviewEmbed({ youtubeId, title }) {
  const [playing, setPlaying] = useState(false);
  if (!youtubeId) return null;

  return (
    <section
      className="py-24 sm:py-32 px-6 sm:px-12"
      style={{ background: "#F5F5F7" }}
      data-testid="drop-interview-section"
    >
      <div className="max-w-4xl mx-auto">
        <span
          className="text-[10px] uppercase block mb-4"
          style={{
            color: "#FF2800",
            letterSpacing: "0.4em",
            fontWeight: 500,
          }}
        >
          ● L&#39;intervista
        </span>
        <h2
          className="text-3xl sm:text-5xl font-extralight mb-10 text-balance"
          style={{ color: "#1D1D1F", letterSpacing: "-0.015em" }}
        >
          La storia raccontata da chi l&#39;ha vissuta.
        </h2>

        <div
          className="relative overflow-hidden group"
          style={{
            aspectRatio: "16 / 9",
            background: "#000",
            borderRadius: 20,
            boxShadow: "0 36px 80px -32px rgba(0,0,0,0.35)",
          }}
        >
          {playing ? (
            <iframe
              data-cookieconsent="ignore"
              title={`Intervista · ${title || "GarageDrops"}`}
              src={`https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0&modestbranding=1`}
              className="absolute inset-0 w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              frameBorder="0"
              data-testid="drop-interview-iframe"
            />
          ) : (
            <button
              type="button"
              onClick={() => setPlaying(true)}
              className="absolute inset-0 w-full h-full text-left"
              aria-label="Riproduci intervista"
              data-testid="drop-interview-play"
            >
              <img
                src={`https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`}
                alt={`Copertina intervista${title ? " · " + title : ""}`}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
                onError={(e) => {
                  if (!e.currentTarget.dataset.fallback) {
                    e.currentTarget.dataset.fallback = "1";
                    e.currentTarget.src = `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
                  }
                }}
              />
              <div
                aria-hidden
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.4) 100%)",
                }}
              />
              <div
                aria-hidden
                className="absolute inset-0 flex items-center justify-center"
              >
                <span
                  className="flex items-center justify-center transition-transform duration-500 group-hover:scale-110"
                  style={{
                    width: 84,
                    height: 84,
                    borderRadius: "50%",
                    background: "#FF2800",
                    boxShadow: "0 20px 40px -10px rgba(255,40,0,0.65)",
                  }}
                >
                  <svg
                    viewBox="0 0 24 24"
                    width="30"
                    height="30"
                    fill="#FFFFFF"
                    aria-hidden="true"
                  >
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </span>
              </div>
              <span
                className="absolute bottom-4 left-4 text-[11px] uppercase tracking-widest"
                style={{
                  color: "rgba(255,255,255,0.9)",
                  fontWeight: 500,
                }}
              >
                Riproduci intervista
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
